const es = {
    'user.table.filter_by_User': 'Filtrar por User',
    'user.table.filter_by_status': 'Filtro por estado',
    'user.table.filter_by_status_all': 'Todos',
    'user.table.filter_by_status_enabled': 'Activos',
    'user.table.filter_by_status_disabled': 'Inactivos',
    'user.table.filter_by_deleted': 'Filtro por eliminados',
    'user.table.filter_by_deleted_all': 'Todos',
    'user.table.filter_by_deleted_deleted': 'Eliminados',
    'user.table.filter_by_deleted_not_deleted': 'No eliminados',
    'user.table.button.create': 'Crear usuario',
    'user.table.title': 'Usuarios',
    'user.table.email': 'Email',
    'user.table.rol': 'Rol',
    'user.table.status': 'Estado',
    'user.table.actions': 'Acciones',
    'user.table.modal.enable.enable': 'Habilitar',
    'user.table.modal.enable.disable': 'Deshabilitar',
    'user.table.modal.enable.done': 'Realizado con éxito',
    'user.table.modal.enable.button.cancel': 'Cancelar',
    'user.table.modal.enable.phrase.enable': '¿Estás seguro de que quieres habilitar este usuario?',
    'user.table.modal.enable.phrase.disable': '¿Estás seguro de que quieres deshabilitar este usuario?',
    'user.table.modal.delete.title': 'Eliminar',
    'user.table.modal.delete.done': 'Realizado con éxito',
    'user.table.modal.delete.phrase': '¿Estás seguro de que quieres eliminar?',
    'user.table.modal.delete.button.cancel': 'Cancelar',
    'user.table.modal.delete.button.delete': 'Eliminar',
    'user.table.modal.restore.title': 'Restaurar',
    'user.table.modal.restore.done': 'Realizado con éxito',
    'user.table.modal.restore.button.cancel': 'Cancelar',
    'user.table.modal.restore.button.restore': 'Restaurar',
    'user.table.impersonate': 'Entrar como',
    'user.table.modal.impersonate.title': 'Entrar como usuario',
    'user.table.modal.impersonate.phrase': '¿Estás seguro de que quieres iniciar sesión como este usuario?',
    'user.table.modal.impersonate.button.confirm': 'Entrar como',
    'user.table.modal.impersonate.button.cancel': 'Cancelar',
    'user.impersonate.revert': 'Volver usuario original',
    'user.impersonate.banner_message': 'Has iniciado sesión como',

    'user.form.update': 'Actualizar usuario',
    'user.form.create': 'Crear usuario',
    'user.form.email': 'Email',
    'user.form.password': 'Contraseña',
    'user.form.password_two': 'Repetir contraseña',
    'user.form.role': 'Rol',
    'user.form.role_user': 'Usuario',
    'user.form.role_admin': 'Administrador',
    'user.form.permissions': 'Permisos',
    'user.form.permission_groups': 'Grupos',
    'user.form.can_access': 'Acceso Intranet',
    'user.form.enabled': 'Habilitado',
    'user.form.cancel': 'Volver',
    'user.form.name': 'Nombre',
    'user.form.firstSurname': 'Primer apellido',
    'user.form.secondSurname': 'Segundo apellido',
    'user.form.dni': 'DNI / NIE',
    'user.form.gender': 'Sexo',
    'user.form.phone': 'Teléfono personal',
    'user.form.workPhone': 'Teléfono de trabajo',
    'user.form.extension': 'Extensión',
    'user.form.shortName': 'Nombre corto',
    'user.form.company': 'Empresa',
    'user.form.delegation': 'Delegación',
    'user.form.jobPosition': 'Puesto de trabajo',
    'user.form.professionalCategory': 'Categoría profesional',
    'user.form.workerId': 'ID de trabajador',
    'user.form.iban': 'IBAN',
    'user.form.isDirectEmployee': 'Empleado directo',
    'user.form.hireDate': 'Fecha de alta',
    'user.form.terminationDate': 'Fecha de baja',
    'user.form.birthDate': 'Fecha de nacimiento',
    'user.form.commissionsExtras': 'Comisiones extra',
    'user.form.commissionsAnnexes': 'Comisiones anexos',
    'user.form.section.personal': 'Datos Personales',
    'user.form.section.contact': 'Datos de Contacto',
    'user.form.section.company': 'Datos de Empresa',
    'user.form.section.labor': 'Configuración Laboral',
    'user.form.section.security': 'Seguridad y Accesos',
    'user.table.name': 'Usuario',
    'user.table.cargo': 'Puesto de trabajo',
    'user.table.dni': 'DNI / NIE',
};

export default es;